<div class="col-lg-12 parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center p-3 pt-1 globalborder-btm-header">
        <span class="col-auto">
          <h2 class="mb-0">Product Summary</h2>
        </span>
        <span class="d-flex gap-3 align-items-center">
          <span>
            <p-button
              label="View Variants"
              (click)="showVariants()"
              *ngIf="
                productSummaryDetail &&
                productSummaryDetail?.productTypeD365 === 'Item'
              " />
          </span>
          <span class="cross-border" (click)="onCloseModal()"
            ><i class="pi pi-times"></i
          ></span>
        </span>
      </span>
      <div class="col-lg-12 adduser-container-hgt p-3">
        <div class="pt-2 pb-2">
          <div>
            <p-panel header="General" [toggleable]="true">
              <div class="collapseable">
                <div class="row">
                  <div class="col-4">
                    <h3 class="mb-2 mt-2">Identification</h3>
                    <form [formGroup]="generalDetailForm">
                      <div
                        class="d-flex flex-column"
                        formGroupName="identification">
                        <div class="form-group has-float-label mb-4">
                          <label class="form-label" for="productType"
                            >Product Type</label
                          >
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control disable-color"
                            formControlName="productType"
                            (keydown)="onKeyDown($event)" />
                        </div>
                        <!-- <div class="form-group has-float-label mb-4">
                  <input pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control"
                    formControlName="productSubtype"
                  />
                  <label class="form-label">Product Subtype</label>
                </div> -->
                        <!-- <div class="form-group has-float-label mb-4">
                  <input pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control"
                    formControlName="productServiceType"
                  />
                  <label class="form-label">Product Service Type</label>
                </div> -->
                        <div class="form-group has-float-label mb-4">
                          <label class="form-label" for="itemNumber"
                            >Item Number</label
                          >
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            formControlName="itemNumber" />
                        </div>
                        <!-- <div class="form-group has-float-label mb-4">
                  <input pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control"
                    formControlName="productNumber"
                  />
                  <label class="form-label">Product Number</label>
                </div> -->
                      </div>
                    </form>
                  </div>
                  <div class="col-4">
                    <h3 class="mb-2 mt-2">Further Identification</h3>
                    <form [formGroup]="generalDetailForm">
                      <div
                        class="d-flex flex-column"
                        formGroupName="furtherIdentification">
                        <div class="form-group has-float-label mb-4">
                          <label class="form-label" for="productName"
                            >Product Name</label
                          >
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control disable-color"
                            formControlName="productName"
                            (keydown)="onKeyDown($event)" />
                        </div>
                        <!-- <div class="form-group has-float-label mb-4">
                  <input pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control"
                    formControlName="searchName"
                  />
                  <label class="form-label">Search Name</label>
                </div> -->
                        <div class="form-group has-float-label mb-4">
                          <label class="form-label" for="description"
                            >Description</label
                          >
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            formControlName="description" />
                        </div>
                        <div class="form-group has-float-label mb-4">
                          <label class="form-label" for="unit">Unit</label>
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            formControlName="unit" />
                        </div>
                        <div class="form-group has-float-label mb-4">
                          <label class="form-label" for="salesPrice"
                            >Sales Price</label
                          >
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            formControlName="salesPrice" />
                        </div>
                        <div class="form-group has-float-label mb-4">
                          <label class="form-label" for="projectCategory"
                            >Project category</label
                          >
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            formControlName="projectCategory" />
                        </div>
                      </div>
                    </form>
                  </div>
                  <!-- <div class="col-4">
            <h2 class="mb-2 mt-2">Administration</h2>
            <form [formGroup]="generalDetailForm">
              <div class="d-flex flex-column" formGroupName="administration">
                <div class="form-group has-float-label mb-4">
                  <input pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control disable-color"
                    formControlName="storageDimensionGroup"
                    (keydown)="onKeyDown($event)"
                  />
                  <label class="form-label">Storage Dimension Group</label>
                </div>
                <div class="form-group has-float-label mb-4">
                  <input pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control"
                    formControlName="trackingDimensionGroup"
                  />
                  <label class="form-label">Tracking Dimension Group</label>
                </div>
                <div class="form-group has-float-label mb-4">
                  <input pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control"
                    formControlName="itemModelGroup"
                  />
                  <label class="form-label">Item Model Group</label>
                </div>
                <div class="form-group has-float-label mb-4">
                  <input pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control"
                    formControlName="reservationHierarchy"
                  />
                  <label class="form-label">Reservation Hierarchy</label>
                </div>
                <div class="form-group has-float-label mb-4">
                  <input pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control"
                    formControlName="countingPolicy"
                  />
                  <label class="form-label">Counting Reason Code Policy</label>
                </div>
                <div class="form-group has-float-label mb-4">
                  <input pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control"
                    formControlName="productLifeCycleState"
                  />
                  <label class="form-label">Product Lifecycle State</label>
                </div>
                <div class="form-group has-float-label mb-4">
                  <input pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control"
                    formControlName="advancedLifeCycle"
                  />
                  <label class="form-label">Advanced Notes Group</label>
                </div>
              </div>
            </form>
          </div> -->
                  <div class="col-4">
                    <h3 class="mb-2 mt-2">Store Defaults</h3>
                    <form [formGroup]="generalDetailForm">
                      <div
                        class="d-flex flex-column"
                        formGroupName="storageDefaults">
                        <div class="form-group has-float-label mb-4">
                          <label class="form-label" for="jniStore">Store</label>
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control disable-color"
                            formControlName="jniStore"
                            (keydown)="onKeyDown($event)" />
                        </div>
                        <div class="form-group has-float-label mb-4">
                          <label class="form-label" for="warehouse"
                            >Default Warehouse</label
                          >
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            formControlName="warehouse" />
                        </div>
                        <div class="form-group has-float-label mb-4">
                          <label class="form-label" for="site"
                            >Default site</label
                          >
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            formControlName="site" />
                        </div>
                        <div class="form-group has-float-label mb-4">
                          <label class="form-label" for="wmsOwner">Owner</label>
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            formControlName="wmsOwner" />
                        </div>
                        <div class="form-group has-float-label mb-4">
                          <label class="form-label" for="productType"
                            >Product Type</label
                          >
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            formControlName="productType" />
                        </div>
                        <div class="form-group has-float-label mb-4">
                          <label class="form-label" for="jniLowstockLevel"
                            >Low Stock Level</label
                          >
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            formControlName="jniLowstockLevel" />
                        </div>
                        <!-- <div class="form-group has-float-label mb-4">
                  <input pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control"
                    formControlName="defaultReceiptLocation"
                  />
                  <label class="form-label">Default receipt location</label>
                </div>
                <div class="form-group has-float-label mb-4">
                  <input pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control"
                    formControlName="defaultIssueLocation"
                  />
                  <label class="form-label">Default issue location</label>
                </div> -->
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </p-panel>
            <p-panel
              header="Financial Dimensions"
              [toggleable]="true"
              *ngIf="showFinancialDimensions">
              <div class="collapseable">
                <div class="row">
                  <div class="col-4">
                    <h3 class="mb-2 mt-2">Default Financial Items</h3>
                    <form [formGroup]="financialDimensionForm">
                      <div class="d-flex flex-column">
                        <div class="form-group has-float-label mb-4">
                          <label class="form-label" for="department"
                            >Department</label
                          >
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control disable-color"
                            formControlName="department"
                            (keydown)="onKeyDown($event)" />
                        </div>
                        <div class="form-group has-float-label mb-4">
                          <label class="form-label" for="location"
                            >Locations</label
                          >
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            formControlName="location" />
                        </div>
                        <div class="form-group has-float-label mb-4">
                          <label class="form-label" for="productCategory"
                            >Product Category</label
                          >
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            formControlName="productCategory" />
                        </div>
                        <div class="form-group has-float-label mb-4">
                          <label class="form-label" for="productSubCategory"
                            >Product Sub Category</label
                          >
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            formControlName="productSubCategory" />
                        </div>
                        <div class="form-group has-float-label mb-4">
                          <label class="form-label" for="program"
                            >Program</label
                          >
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            formControlName="program" />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </p-panel>
          </div>
        </div>
      </div>
    </p-card>
  </div>
</div>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="variantsListingModal"
  [displayModal]="variantsListingModal"
  (closeEvent)="closeModalForVariantsListing()">
  <h1 class="panelHeading">Variants</h1>
  <div class="panelBody">
    <jni-variants-listing
      [itemNumber]="selectedVariantItemNumber"
      [productName]="productSummaryDetail.nameD365 || ''"
      (closeModalEvent)="closeModalForVariantsListing()"></jni-variants-listing>
  </div>
</jni-modal-stacker>
